// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--wrap {\n  background: whitesmoke;\n}\n.v-input--is-disabled input,\n.v-input--is-disabled textarea {\n  color: rgba(0, 0, 0, 0.8) !important;\n}\n.bg-light-primary {\n  background: #e8f2ff !important;\n}\n.border-bottom-light {\n  border-bottom: 1px solid #e0e0e0;\n}\n.bg-whitesmoke {\n  background: #e8f2ff !important;\n}\n.bg-white {\n  background: #fff !important;\n}", ""]);
// Exports
module.exports = exports;
